import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@ui/button';
import { SmolLink } from '@web/atoms';
import {
  StyledCookieBanner,
  Heading,
  Subheading,
  BottomRowContainer,
  LinksContainer,
} from './styles';

export const CookieBanner = ({
  heading,
  subheading,
  buttonCopy = 'Accept',
  buttonVariant = 'secondary',
  preLinkCopy = 'Read our',
  links,
}) => {
  const [isOpen, setIsOpen] = useState(true);
  return (
    <StyledCookieBanner isOpen={isOpen}>
      <Heading>{heading}</Heading>
      <Subheading>{subheading}</Subheading>
      <BottomRowContainer>
        <Button
          variant={buttonVariant}
          onClick={() => setIsOpen(false)}
          verticalPadding={3}
          horizontalPadding={9}
        >
          {buttonCopy}
        </Button>
        <LinksContainer>
          {links.length >= 1 && (
            <>
              {preLinkCopy}{' '}
              <SmolLink underline href={links[0].target}>
                {links[0].text}
              </SmolLink>
            </>
          )}
          {links.length === 2 && (
            <>
              {' and '}
              <SmolLink underline href={links[1].target}>
                {links[1].text}
              </SmolLink>
            </>
          )}
        </LinksContainer>
      </BottomRowContainer>
    </StyledCookieBanner>
  );
};

CookieBanner.displayName = 'CookieBanner';

CookieBanner.propTypes = {
  heading: PropTypes.string,
  subheading: PropTypes.string,
  buttonCopy: PropTypes.string,
  buttonVariant: PropTypes.string,
  preLinkCopy: PropTypes.string,
  links: PropTypes.array,
};
